import Api from '../functions/api';
import { serialize } from '../functions/objectToQuery';

const ativarOuInativar = (id, active) => {
  return Api.put(`/InstituicaoDeEnsino/${active ? 'ativar' : 'desativar'}/${id}`);
};

const criar = (body) => {
  return Api.post('/InstituicaoDeEnsino', body);
};

const editar = (id, body) => {
  return Api.put(`/InstituicaoDeEnsino/${id}`, body);
};

const obterFiltradaPaginada = (filter) => {
  return Api.get(`/InstituicaoDeEnsino/Filtro/?${serialize(filter)}`);
};

const obterInstituicoes = () => {
  return Api.get('/InstituicaoDeEnsino');
};

const obterInstituicoesFiltradas = (filter) => {
  return Api.get(`/InstituicaoDeEnsino/?${serialize(filter)}`);
};

const obterModalidadesPorInstuticao = (id) => {
  return Api.get(`/InstituicaoDeEnsinoModalidade/${id}`);
};

const obterRelatorioInstituicaoAprovadores = (filter) => {
  return Api.get(`/InstituicaoDeEnsino/RelatorioInstituicaoAprovador/csv?${serialize(filter)}`, {
    responseType: 'blob',
  });
};

const obterPorId = (id) => {
  return Api.get(`/InstituicaoDeEnsino/${id}`);
};

export const InstituicaoStore = {
  ativarOuInativar,
  criar,
  editar,
  obterFiltradaPaginada,
  obterInstituicoes,
  obterInstituicoesFiltradas,
  obterModalidadesPorInstuticao,
  obterRelatorioInstituicaoAprovadores,
  obterPorId,
};
